module.exports = __webpack_public_path__ + "media/theme/tag-off-left-bg-086ccf8a.png";